<template>
  <div>
    <div class="cards columns is-multiline">
      <div
        class="cards__card column is-4 is-desktop"
        v-for="(layout, index) in arrayLayouts"
        :key="index"
      >
        <div
          class="cards__card__item"
          :ref="layout.title"
          :title="layout.title"
        >
          <p>{{ layout.name }}</p>
          <div class="cards__card__item--img">
            <router-link :to="{ path: layout.title }" append
              ><img :src="layout.img" :alt="layout.name" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    arrayLayouts: {
      type: Array,
      required: true,
    },
  },

  metaInfo: {
    title: 'Convites',
  },
}
</script>

<style lang="scss" scoped>
.selected {
  background-color: #f3f3f35c;
}

.cards {
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  margin-top: 50px;
  justify-content: center;

  &__card {
    max-width: 350px;
    margin-bottom: 45px;

    p {
      font-weight: bold;
      color: #6e7983;
      margin-bottom: 28px;
    }

    &__item {
      &--img {
        border: solid 1px $gray-4;

        a {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      &:hover {
        p {
          color: $primary;
        }

        div {
          transition: ease 0.3s;
          box-shadow: 0px 0px 12px 2px rgba(191, 200, 209, 1);
        }
      }
    }

    @media (max-width: 767px) {
      max-width: 100%;
      margin-bottom: 32px;
    }
  }
  @media (max-width: 767px) {
    display: block;
  }
}
</style>
